module.exports = __webpack_public_path__ + "img/home-banner.02b2b07b.png";